import { Component, OnInit } from '@angular/core';
import { ElectronicInvoicingService, FiscalSetupService, IFiscalSetup } from 'src/app/xena-api';

@Component({
    selector: 'app-nem-handel',
    templateUrl: './nem-handel.component.html',
    styleUrls: ['./nem-handel.component.scss'],
    standalone: false
})
export class NemHandelComponent implements OnInit {
  open: boolean = true;
  loading: boolean = false;
  success: boolean = false;
  fiscalSetup: IFiscalSetup;

  constructor(
    private electronicInvoicingService: ElectronicInvoicingService,
    private fiscalsetupService: FiscalSetupService
  ) { }

  ngOnInit(): void {
    this.fiscalsetupService.get().subscribe(fs => this.fiscalSetup = fs);
  }

  get name(): string {
    return this.fiscalSetup?.address?.name || '';
  }

  get orgNumber(): string {
    return this.fiscalSetup?.orgNumber || '';
  }

  close() {
    this.open = false;
  }

  async register() {
    this.loading = true;
    await this.electronicInvoicingService.postRegisterNemHandel().toPromise().then(
      () => this.success = true,
      () => this.loading = false
    );
  }
}
